/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformEphemerisDailyResponse } from '../models/platform-ephemeris-daily-response';
import { PlatformEphemerisMomentResponse } from '../models/platform-ephemeris-moment-response';
import { PlatformEphemerisNowNextResponse } from '../models/platform-ephemeris-now-next-response';
import { PlatformEphemerisPositionsBatchResponse } from '../models/platform-ephemeris-positions-batch-response';
import { PlatformEphemerisPositionsResponse } from '../models/platform-ephemeris-positions-response';
import { PlatformEphemerisSegmentsResponse } from '../models/platform-ephemeris-segments-response';
import { PlatformEphemerisTableResponse } from '../models/platform-ephemeris-table-response';
import { getEphemerisDaily } from '../fn/ephemeris/get-ephemeris-daily';
import { GetEphemerisDaily$Params } from '../fn/ephemeris/get-ephemeris-daily';
import { getEphemerisMoment } from '../fn/ephemeris/get-ephemeris-moment';
import { GetEphemerisMoment$Params } from '../fn/ephemeris/get-ephemeris-moment';
import { getEphemerisNowNext } from '../fn/ephemeris/get-ephemeris-now-next';
import { GetEphemerisNowNext$Params } from '../fn/ephemeris/get-ephemeris-now-next';
import { getEphemerisPositions } from '../fn/ephemeris/get-ephemeris-positions';
import { GetEphemerisPositions$Params } from '../fn/ephemeris/get-ephemeris-positions';
import { getEphemerisSegments } from '../fn/ephemeris/get-ephemeris-segments';
import { GetEphemerisSegments$Params } from '../fn/ephemeris/get-ephemeris-segments';
import { getEphemerisTable } from '../fn/ephemeris/get-ephemeris-table';
import { GetEphemerisTable$Params } from '../fn/ephemeris/get-ephemeris-table';
import { postEphemerisPositionsBatch } from '../fn/ephemeris/post-ephemeris-positions-batch';
import { PostEphemerisPositionsBatch$Params } from '../fn/ephemeris/post-ephemeris-positions-batch';


/**
 * API voor ephemeris/transit-queries: poort- en lijn-transits, huidige stand met
 * omliggende overgangen, en ruwe planetaire posities.
 * Gebouwd op de TransitSegmentSolver (échte overgangsgrenzen, retrograde-proof).
 */
@Injectable({ providedIn: 'root' })
export class PlatformEphemerisService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getEphemerisSegments()` */
  static readonly GetEphemerisSegmentsPath = '/api/Ephemeris/segments';

  /**
   * Transit-segmenten en stations per planeet over een UTC-venster.
   * Segmenten hebben échte overgangsgrenzen (ook buiten het venster) en sluiten aan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEphemerisSegments()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisSegments$Response(params?: GetEphemerisSegments$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisSegmentsResponse>> {
    return getEphemerisSegments(this.http, this.rootUrl, params, context);
  }

  /**
   * Transit-segmenten en stations per planeet over een UTC-venster.
   * Segmenten hebben échte overgangsgrenzen (ook buiten het venster) en sluiten aan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEphemerisSegments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisSegments(params?: GetEphemerisSegments$Params, context?: HttpContext): Observable<PlatformEphemerisSegmentsResponse> {
    return this.getEphemerisSegments$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformEphemerisSegmentsResponse>): PlatformEphemerisSegmentsResponse => r.body)
    );
  }

  /** Path part for operation `getEphemerisNowNext()` */
  static readonly GetEphemerisNowNextPath = '/api/Ephemeris/now-next';

  /**
   * Huidige stand per planeet op atUtc met de omliggende lijn- en poort-overgangen.
   *             
   * Semantiek:
   * - current  = het lijn-segment op atUtc (sinceUtc = de échte start van dat segment);
   * - nextLine = het volgende lijn-segment: atUtc = einde van current (tevens diens échte
   *   start), gate/line = identiteit van dat segment (bepaald via de positie 1 seconde
   *   na de overgang);
   * - prevLine = het vorige lijn-segment: atUtc = diens échte start (opgehaald via een
   *   tweede solver-call op een klein venster vlak vóór current.sinceUtc — de solver
   *   levert échte grenzen en de dag-cache maakt dit goedkoop);
   * - prevGate/nextGate = analoog op poort-niveau; currentGate = het poort-segment op
   *   atUtc met sinceUtc = de échte start (de "poort-variant" van current);
   * - retrograde (planeten-niveau) = teken van de snelheid in ecliptische lengte op
   *   atUtc. Zon/Maan gaan nooit retrograde, de nodes vrijwel altijd — er wordt gewoon
   *   gerapporteerd wat de data zegt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEphemerisNowNext()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisNowNext$Response(params?: GetEphemerisNowNext$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisNowNextResponse>> {
    return getEphemerisNowNext(this.http, this.rootUrl, params, context);
  }

  /**
   * Huidige stand per planeet op atUtc met de omliggende lijn- en poort-overgangen.
   *             
   * Semantiek:
   * - current  = het lijn-segment op atUtc (sinceUtc = de échte start van dat segment);
   * - nextLine = het volgende lijn-segment: atUtc = einde van current (tevens diens échte
   *   start), gate/line = identiteit van dat segment (bepaald via de positie 1 seconde
   *   na de overgang);
   * - prevLine = het vorige lijn-segment: atUtc = diens échte start (opgehaald via een
   *   tweede solver-call op een klein venster vlak vóór current.sinceUtc — de solver
   *   levert échte grenzen en de dag-cache maakt dit goedkoop);
   * - prevGate/nextGate = analoog op poort-niveau; currentGate = het poort-segment op
   *   atUtc met sinceUtc = de échte start (de "poort-variant" van current);
   * - retrograde (planeten-niveau) = teken van de snelheid in ecliptische lengte op
   *   atUtc. Zon/Maan gaan nooit retrograde, de nodes vrijwel altijd — er wordt gewoon
   *   gerapporteerd wat de data zegt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEphemerisNowNext$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisNowNext(params?: GetEphemerisNowNext$Params, context?: HttpContext): Observable<PlatformEphemerisNowNextResponse> {
    return this.getEphemerisNowNext$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformEphemerisNowNextResponse>): PlatformEphemerisNowNextResponse => r.body)
    );
  }

  /** Path part for operation `getEphemerisPositions()` */
  static readonly GetEphemerisPositionsPath = '/api/Ephemeris/positions';

  /**
   * Ruwe planetaire posities op atUtc plus de Human Design gate/line-activering.
   * Per planeet één provider-call; gate/line via GateLineMapper (Personality-side).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEphemerisPositions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisPositions$Response(params?: GetEphemerisPositions$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisPositionsResponse>> {
    return getEphemerisPositions(this.http, this.rootUrl, params, context);
  }

  /**
   * Ruwe planetaire posities op atUtc plus de Human Design gate/line-activering.
   * Per planeet één provider-call; gate/line via GateLineMapper (Personality-side).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEphemerisPositions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisPositions(params?: GetEphemerisPositions$Params, context?: HttpContext): Observable<PlatformEphemerisPositionsResponse> {
    return this.getEphemerisPositions$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformEphemerisPositionsResponse>): PlatformEphemerisPositionsResponse => r.body)
    );
  }

  /** Path part for operation `postEphemerisPositionsBatch()` */
  static readonly PostEphemerisPositionsBatchPath = '/api/Ephemeris/positions/batch';

  /**
   * Zelfde posities als GET positions, maar op meerdere momenten in één opvraging (hoogstens
   * MaxBatchMoments). Bedoeld voor de exports van dagboek en momenten: per item
   * GET positions zou bij een groot dagboek tegen de 300/min-limiet lopen.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postEphemerisPositionsBatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postEphemerisPositionsBatch$Response(params: PostEphemerisPositionsBatch$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisPositionsBatchResponse>> {
    return postEphemerisPositionsBatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Zelfde posities als GET positions, maar op meerdere momenten in één opvraging (hoogstens
   * MaxBatchMoments). Bedoeld voor de exports van dagboek en momenten: per item
   * GET positions zou bij een groot dagboek tegen de 300/min-limiet lopen.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postEphemerisPositionsBatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postEphemerisPositionsBatch(params: PostEphemerisPositionsBatch$Params, context?: HttpContext): Observable<PlatformEphemerisPositionsBatchResponse> {
    return this.postEphemerisPositionsBatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformEphemerisPositionsBatchResponse>): PlatformEphemerisPositionsBatchResponse => r.body)
    );
  }

  /** Path part for operation `getEphemerisTable()` */
  static readonly GetEphemerisTablePath = '/api/Ephemeris/table';

  /**
   * Ephemeris in tabelvorm: elke lijn-/poortwissel en elk station van de 13 HD-planeten,
   * Chiron en Black Moon Lilith over [fromUtc, toUtc). Voedt de ephemeris-pagina
   * (spec 2026-10-13-ephemeris-pagina-design).
   *             
   * Grenzen: venster ≤ 31 dagen en volledig binnen [1802-01-01, 2398-01-01) (de dekking
   * van de ephemeris-bestanden met marge); beide worden in de response meegegeven.
   * Strakke rate limit per gebruiker (policy ephemeris-table).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEphemerisTable()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisTable$Response(params?: GetEphemerisTable$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisTableResponse>> {
    return getEphemerisTable(this.http, this.rootUrl, params, context);
  }

  /**
   * Ephemeris in tabelvorm: elke lijn-/poortwissel en elk station van de 13 HD-planeten,
   * Chiron en Black Moon Lilith over [fromUtc, toUtc). Voedt de ephemeris-pagina
   * (spec 2026-10-13-ephemeris-pagina-design).
   *             
   * Grenzen: venster ≤ 31 dagen en volledig binnen [1802-01-01, 2398-01-01) (de dekking
   * van de ephemeris-bestanden met marge); beide worden in de response meegegeven.
   * Strakke rate limit per gebruiker (policy ephemeris-table).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEphemerisTable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisTable(params?: GetEphemerisTable$Params, context?: HttpContext): Observable<PlatformEphemerisTableResponse> {
    return this.getEphemerisTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformEphemerisTableResponse>): PlatformEphemerisTableResponse => r.body)
    );
  }

  /** Path part for operation `getEphemerisDaily()` */
  static readonly GetEphemerisDailyPath = '/api/Ephemeris/daily';

  /**
   * Dagposities zoals in een gedrukte ephemeris: elk lichaam om 00:00 UT (de Maan ook om
   * 12:00 UT) met de ecliptische lengte, de richting en de HD-activatie
   * (poort.lijn.kleur.toon.basis). Aanvulling op /table: met de graden reken je exacte
   * momenten uit (solar return, design-moment) door lineair te interpoleren.
   *             
   * Zelfde grenzen als /table (max. 31 dagen, binnen de dekking) en dezelfde rate-limit-bucket.
   * Eén dag per UT-middernacht binnen [fromUtc, toUtc).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEphemerisDaily()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisDaily$Response(params?: GetEphemerisDaily$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisDailyResponse>> {
    return getEphemerisDaily(this.http, this.rootUrl, params, context);
  }

  /**
   * Dagposities zoals in een gedrukte ephemeris: elk lichaam om 00:00 UT (de Maan ook om
   * 12:00 UT) met de ecliptische lengte, de richting en de HD-activatie
   * (poort.lijn.kleur.toon.basis). Aanvulling op /table: met de graden reken je exacte
   * momenten uit (solar return, design-moment) door lineair te interpoleren.
   *             
   * Zelfde grenzen als /table (max. 31 dagen, binnen de dekking) en dezelfde rate-limit-bucket.
   * Eén dag per UT-middernacht binnen [fromUtc, toUtc).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEphemerisDaily$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisDaily(params?: GetEphemerisDaily$Params, context?: HttpContext): Observable<PlatformEphemerisDailyResponse> {
    return this.getEphemerisDaily$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformEphemerisDailyResponse>): PlatformEphemerisDailyResponse => r.body)
    );
  }

  /** Path part for operation `getEphemerisMoment()` */
  static readonly GetEphemerisMomentPath = '/api/Ephemeris/moment';

  /**
   * Posities van alle lichamen op één moment (de Maan ook 6 uur later), met graad, richting
   * en HD-activatie. Voor de rijen die de gebruiker zelf tussenvoegt op de ephemeris-pagina.
   * Zelfde dekking en dezelfde rate-limit-bucket als /table en /daily.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEphemerisMoment()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisMoment$Response(params?: GetEphemerisMoment$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisMomentResponse>> {
    return getEphemerisMoment(this.http, this.rootUrl, params, context);
  }

  /**
   * Posities van alle lichamen op één moment (de Maan ook 6 uur later), met graad, richting
   * en HD-activatie. Voor de rijen die de gebruiker zelf tussenvoegt op de ephemeris-pagina.
   * Zelfde dekking en dezelfde rate-limit-bucket als /table en /daily.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEphemerisMoment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEphemerisMoment(params?: GetEphemerisMoment$Params, context?: HttpContext): Observable<PlatformEphemerisMomentResponse> {
    return this.getEphemerisMoment$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformEphemerisMomentResponse>): PlatformEphemerisMomentResponse => r.body)
    );
  }

}
